import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filters } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import classNames from "classnames";
import { forwardRef, memo } from "react";
import { NEW_FILTERS_BUTTON } from "~/constants/testIDs";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
const _FiltersButton = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { filtersCount, isActive, ...props } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const hasFilters = !!filtersCount;
    return /*#__PURE__*/ _jsxs(Button, {
        appearance: "ghost",
        color: isActive || hasFilters ? "blue" : "grey",
        className: classNames("px-2.5", isActive || hasFilters ? "bg-blue-3 hover:bg-blue-5 active:bg-blue-5" : undefined),
        "data-testid": NEW_FILTERS_BUTTON,
        ref: ref,
        size: searchImprovements ? "medium" : "large",
        suffix: searchImprovements && !!filtersCount && /*#__PURE__*/ _jsx("div", {
            className: "flex h-4 min-w-[16px] shrink-0 items-center justify-center rounded-24 bg-blue-11 px-1 text-center text-10 font-bold text-blue-1",
            "data-testid": "NEW_FILTERS_BUTTON_COUNT",
            children: filtersCount
        }),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(Filters, {
                className: classNames(searchImprovements ? "size-4" : "size-5")
            }),
            !!filtersCount && !searchImprovements && /*#__PURE__*/ _jsx("div", {
                "data-testid": "NEW_FILTERS_BUTTON_COUNT",
                className: "ml-2 mr-0.5 rounded-16 bg-jay-300/15 px-1.5 text-14 font-semibold text-inherit",
                children: filtersCount
            })
        ]
    });
});
_FiltersButton.displayName = "_FiltersButton";
export const FiltersButton = /*#__PURE__*/ memo(_FiltersButton);
FiltersButton.displayName = "FiltersButton";
